"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppDrawer;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("simplebar-react/dist/simplebar.min.css");
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _simplebarReact = _interopRequireDefault(require("simplebar-react"));
var _Snackbar = _interopRequireDefault(require("../Snackbar"));
var _MenuIcon, _InvertColorsIcon, _AccountCircleIcon, _KeyboardArrowRightIc, _KeyboardArrowLeftIco;
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    '@global': {
      '.simplebar-mask': {
        zIndex: 'auto'
      },
      '.simplebar-scrollbar.simplebar-visible:before': {
        opacity: 1
      },
      '.simplebar-scrollbar:before': {
        backgroundColor: 'rgba(255,255,255,1)'
      },
      '.simplebar-track.simplebar-vertical': {
        width: 7
      }
    },
    appBar: {
      color: theme.palette.text.primary,
      position: 'fixed',
      zIndex: theme.zIndex.drawer + 1
    },
    collapseButton: {
      alignItems: 'center',
      background: '#424242',
      borderRadius: '50%',
      bottom: '2vh',
      boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 10px 4px, 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.2)',
      color: theme.palette.primary.contrastText,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      height: 32,
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'fixed',
      transform: 'translate(-50%)',
      width: 32,
      zIndex: 3
    },
    collapseButtonClose: {
      left: theme.mixins.mainMenu.drawerWidth,
      transition: theme.transitions.create('left', {
        duration: theme.transitions.duration.leavingScreen,
        easing: theme.transitions.easing.sharp
      })
    },
    collapseButtonOpen: {
      left: theme.mixins.mainMenu.collapsedDrawerWidth,
      transition: theme.transitions.create('left', {
        duration: theme.transitions.duration.enteringScreen,
        easing: theme.transitions.easing.sharp
      })
    },
    content: {
      backgroundColor: theme.palette.background.default,
      flexGrow: 1,
      height: '100%',
      padding: '0 0 250px 0'
    },
    contentWithDrawer: {
      [theme.breakpoints.up('md')]: {
        marginLeft: theme.mixins.mainMenu.drawerWidth
      }
    },
    drawerClose: {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.leavingScreen,
        easing: theme.transitions.easing.sharp
      }),
      width: theme.mixins.mainMenu.collapsedDrawerWidth
    },
    drawerOpen: {
      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.enteringScreen,
        easing: theme.transitions.easing.sharp
      }),
      width: theme.mixins.mainMenu.drawerWidth
    },
    drawerPaper: {
      width: theme.mixins.mainMenu.drawerWidth,
      [theme.breakpoints.up('md')]: {
        position: 'fixed'
      }
    },
    hide: {
      display: 'none'
    },
    logoButton: {
      '&:hover': {
        background: 'none'
      },
      borderRadius: 10,
      color: theme.palette.text.primary,
      display: 'grid',
      height: '100%',
      marginLeft: -8
    },
    logoButtonContainer: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      overflow: 'hidden'
    },
    mainMenuRoot: {
      backgroundImage: function backgroundImage(_ref) {
        var _backgroundImage = _ref.backgroundImage;
        return "url(".concat(_backgroundImage, ")");
      },
      backgroundSize: 'cover',
      flex: 99,
      overflow: 'hidden'
    },
    navIconHide: {
      [theme.breakpoints.up('md')]: {
        display: 'none'
      }
    },
    root: {
      backgroundColor: theme.palette.background.default,
      minHeight: '100%'
    },
    simpleBar: {
      marginTop: 60,
      maxHeight: '90%'
    },
    snackbarIcon: {
      marginRight: 10,
      verticalAlign: 'middle'
    },
    toolbar: theme.mixins.toolbar,
    version: {
      textTransform: 'initial'
    }
  };
});
function AppDrawer(_ref2) {
  var _snackbarProps$messag;
  var AccountMenu = _ref2.AccountMenu,
    backgroundImage = _ref2.backgroundImage,
    closeAccountMenu = _ref2.closeAccountMenu,
    closeMainMenu = _ref2.closeMainMenu,
    closeSnackbar = _ref2.closeSnackbar,
    darkMode = _ref2.darkMode,
    id = _ref2.id,
    isAccountMenuOpen = _ref2.isAccountMenuOpen,
    isMainMenuOpen = _ref2.isMainMenuOpen,
    isSnackbarOpen = _ref2.isSnackbarOpen,
    Logo = _ref2.Logo,
    MainMenu = _ref2.MainMenu,
    openAccountMenu = _ref2.openAccountMenu,
    openMainMenu = _ref2.openMainMenu,
    snackbarProps = _ref2.snackbarProps,
    toggleDarkMode = _ref2.toggleDarkMode,
    version = _ref2.version,
    collapsed = _ref2.collapsed,
    toggleCollapsed = _ref2.toggleCollapsed,
    toolbarElements = _ref2.toolbarElements;
  var classes = useStyles({
    backgroundImage
  });
  var theme = (0, _material.useTheme)();
  var _React$useState = _react.default.useState(null),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  function handleClick(event) {
    setAnchorEl(event.currentTarget);
    openAccountMenu();
  }
  function handleClose() {
    setAnchorEl(null);
    closeAccountMenu();
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_material.ThemeProvider, {
    key: "AppBar",
    theme: (0, _material.createTheme)({
      palette: {
        mode: darkMode ? 'dark' : 'light'
      }
    })
  }, /*#__PURE__*/_react.default.createElement(_material.AppBar, {
    className: classes.appBar,
    color: "inherit",
    id: id
  }, /*#__PURE__*/_react.default.createElement(_material.Toolbar, {
    id: "".concat(id, "Toolbar")
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "Open main menu",
    className: classes.navIconHide,
    id: "".concat(id, "OpenMobileMenuButton"),
    onClick: openMainMenu,
    size: "large"
  }, _MenuIcon || (_MenuIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Menu, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.logoButtonContainer
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: classes.logoButton,
    component: _reactRouterDom.Link,
    disableFocusRipple: true,
    disableRipple: true,
    id: "".concat(id, "LogoButton"),
    to: "/"
  }, /*#__PURE__*/_react.default.createElement(Logo, null)), version && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.version,
    color: "textSecondary",
    id: "".concat(id, "Version"),
    variant: "caption"
  }, version)), toolbarElements, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    id: "".concat(id, "ToggleDarkModeButton"),
    onClick: function onClick() {
      return toggleDarkMode();
    },
    size: "large"
  }, _InvertColorsIcon || (_InvertColorsIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.InvertColors, null))), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-controls": isAccountMenuOpen ? 'accountMenu' : null,
    "aria-haspopup": "true",
    "aria-label": "Open account menu",
    id: "".concat(id, "OpenAccountMenuButton"),
    onClick: function onClick(e) {
      return handleClick(e);
    },
    size: "large"
  }, _AccountCircleIcon || (_AccountCircleIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.AccountCircle, null))), /*#__PURE__*/_react.default.createElement(_material.Menu, {
    anchorEl: anchorEl,
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    id: "".concat(id, "AccountMenuContainer"),
    keepMounted: true,
    onClose: function onClose(e) {
      return handleClose(e);
    },
    open: isAccountMenuOpen,
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    }
  }, /*#__PURE__*/_react.default.createElement(AccountMenu, {
    id: "".concat(id, "AccountMenu")
  })))))), /*#__PURE__*/_react.default.createElement(_material.Hidden, {
    key: "OverlayDrawer",
    implementation: "css",
    mdUp: true
  }, /*#__PURE__*/_react.default.createElement(_material.Drawer, {
    anchor: theme.direction === 'rtl' ? 'right' : 'left',
    classes: {
      paper: classes.drawerPaper
    },
    id: "".concat(id, "MobileMenuDrawer"),
    ModalProps: {
      keepMounted: true // Better open performance on mobile.
    },
    onClose: closeMainMenu,
    open: isMainMenuOpen,
    variant: "temporary"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mainMenuRoot
  }, /*#__PURE__*/_react.default.createElement(_simplebarReact.default, {
    className: classes.simpleBar
  }, /*#__PURE__*/_react.default.createElement(MainMenu, {
    closeMenu: closeMainMenu,
    id: "".concat(id, "MobileMenu")
  }))))), /*#__PURE__*/_react.default.createElement(_material.Hidden, {
    key: "StaticDrawer",
    implementation: "css",
    mdDown: true
  }, /*#__PURE__*/_react.default.createElement(_material.Drawer, {
    anchor: theme.direction === 'rtl' ? 'right' : 'left',
    classes: {
      paper: (0, _classnames.default)({
        [classes.drawerOpen]: !collapsed,
        [classes.drawerClose]: collapsed
      })
    },
    className: (0, _classnames.default)({
      [classes.drawerOpen]: !collapsed,
      [classes.drawerClose]: collapsed
    }),
    id: "".concat(id, "MenuDrawer"),
    open: true,
    variant: "permanent"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mainMenuRoot
  }, /*#__PURE__*/_react.default.createElement(_simplebarReact.default, {
    className: classes.simpleBar
  }, /*#__PURE__*/_react.default.createElement(MainMenu, {
    collapsed: collapsed,
    collapsible: !!toggleCollapsed,
    id: "".concat(id, "Menu")
  })), toggleCollapsed && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.collapseButton, {
      [classes.collapseButtonOpen]: collapsed,
      [classes.collapseButtonClose]: !collapsed
    }),
    onClick: toggleCollapsed,
    onKeyPress: toggleCollapsed,
    role: "button",
    tabIndex: 0
  }, collapsed ? _KeyboardArrowRightIc || (_KeyboardArrowRightIc = /*#__PURE__*/_react.default.createElement(_iconsMaterial.KeyboardArrowRight, null)) : _KeyboardArrowLeftIco || (_KeyboardArrowLeftIco = /*#__PURE__*/_react.default.createElement(_iconsMaterial.KeyboardArrowLeft, null)))))), /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
    id: "".concat(id, "Snackbar"),
    message: (_snackbarProps$messag = snackbarProps.message) != null && _snackbarProps$messag.id ? /*#__PURE__*/_react.default.createElement("span", {
      id: "".concat(id, "SnackbarMessage")
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: snackbarProps.message.id,
      values: snackbarProps.message.values
    })) : /*#__PURE__*/_react.default.createElement("span", {
      id: "".concat(id, "SnackbarMessage")
    }, snackbarProps.message),
    onClose: closeSnackbar,
    open: isSnackbarOpen,
    variant: snackbarProps.type
  }));
}